export class ParametrosGerais {
    public codConvenioRefin!: string;
    public codLibCliente!: string;
    public codLibTransfer!: string;
    public codLibRefin!: string;
    public codBaixaRefin!: string;
    public codLibTransferCartaSaldo!: string;
}